export default "__VITE_ASSET__DoqW3eOj__"